/** @jsxImportSource @emotion/react */

import React from "react";
import createReactClass from "create-react-class";
import * as Immutable from "immutable";
import ReactPropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import onClickOutside from "react-onclickoutside";
import VelocityTransitionGroup from "velocity-react/velocity-transition-group";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/pro-regular-svg-icons";
import {Chip} from "@mui/material";

import InfiniteList from "js/common/views/infinite-loading/infinite-list";
import * as Styles from "js/common/views/infinite-loading/infinite-list-select.styles";
import * as DropdownSections from "js/common/views/dropdown-scroll-sections.styles";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const InfiniteListSelect = createReactClass({
  propTypes: {
    searchUrl: ReactPropTypes.string,
    searchParams: ReactPropTypes.object,
    searchResultToItem: ReactPropTypes.func,
    placeholder: ReactPropTypes.node,
    itemHeight: ReactPropTypes.number,
    itemIcon: ReactPropTypes.object,
    startItems: ImmutablePropTypes.list,
    startItemStyle: ReactPropTypes.object,
    startItemIcon: ReactPropTypes.object,
    selectedItems: ImmutablePropTypes.set,
    menuFooterCreatorFn: ReactPropTypes.oneOfType([ReactPropTypes.func, ReactPropTypes.node]),
    onChange: ReactPropTypes.func.isRequired,
    onRequestClose: ReactPropTypes.func,
    disabled: ReactPropTypes.bool,
    keys: ReactPropTypes.array,
    onInputChange: ReactPropTypes.func,
    closeOnSelect: ReactPropTypes.bool,
    style: ReactPropTypes.object,
    innerStyle: ReactPropTypes.object,
    maxHeight: ReactPropTypes.number,
    dataTestId: ReactPropTypes.string
  },

  getInitialState() {
    return {
      searchInput: "",
      isOpen: false,
      listMaxHeight: null
    };
  },

  componentDidUpdate(prevProps) {
    if (this.props.showSelectedInDropdown &&
        this.state.isOpen &&
        prevProps.selectedItems !== this.props.selectedItems) {
      // Selecting/removing items changes the chrome above the list, so re-measure.
      this.recomputeListMaxHeight();
      // Keep the most recently selected item in view when the selection grows.
      if (this.props.selectedItems.size > prevProps.selectedItems.size && this.selectedSectionRef) {
        this.selectedSectionRef.scrollTop = this.selectedSectionRef.scrollHeight;
      }
    }
  },

  componentWillUnmount() {
    this.teardownMenuMeasurement();
  },

  getDefaultProps() {
    return {
      selectedItems: Immutable.Set(),
      keys: ["id", "name", "name"],
      disabled: false,
      itemHeight: 32,
      onInputChange: () => {},
      onRequestClose: () => {},
      menuFooterCreatorFn: () => null,
      closeOnSelect: false,
      maxHeight: 200
    };
  },

  render() {
    const {theme} = this.context;
    const {placeholder, selectedItems, disabled, style, innerStyle} = this.props;
    const {isOpen, searchInput} = this.state;
    const bgColor = this.props.bgColor ? this.props.bgColor : "card";
    let placeholderToShow;
    if (searchInput === "") {
      if (this.props.showSelectedInDropdown) {
        placeholderToShow = placeholder;
      } else {
        if (selectedItems.isEmpty()) {
          placeholderToShow = placeholder;
        } else {
          placeholderToShow = "";
        }
      }
    } else {
      placeholderToShow = "";
    }
    // TODO: Replace onClick with onFocus to fix list not expanding with keyboard focusing
    return (
        <div style={{...{position: "relative"}, ...style}}>
          <div
              css={Styles.selectWrapperStyles(theme, bgColor, disabled)}
              style={innerStyle}
              onClick={isOpen ? () => {} : this.openMenu}>
            <div style={{flex: 1}}>
              {!this.props.showSelectedInDropdown && selectedItems.map(item => this.renderSelectedItem(item, theme.palette))}
              <input
                  ref={ref => this.input = ref}
                  type="text"
                  value={searchInput}
                  css={Styles.selectInputStyle(theme, searchInput, isOpen)}
                  onChange={this.handleInputChange}
                  data-test-id = "infinite-list-search"
                  placeholder={"Type here to search"}
              />
              {!isOpen && placeholderToShow}
            </div>
            <div css={Styles.iconZoneStyle} data-test-id={this.props.dataTestId}>
              {!this.props.showSelectedInDropdown && selectedItems.count() !== 0 &&
                  <span onClick={this.handleRemoveAllItems}>
                &times;
              </span>}
              <FontAwesomeIcon
                  icon={isOpen ? faChevronUp : faChevronDown}
                  onClick={isOpen ? this.closeMenu : this.openMenu} />
            </div>
          </div>
          <VelocityTransitionGroup
              component="div"
              enter="slideDown"
              css={isOpen
                  ? Styles.dropdownOpenStyle(theme, this.props.showSelectedInDropdown)
                  : Styles.dropdownClosedStyle(theme)}>

            {isOpen && <div>{this.renderMenu()}</div>}
          </VelocityTransitionGroup>
        </div>
    );
  },

  renderSelectedItem(item, palette) {
    const [valueKey, labelKey] = this.props.keys;
    const label = item.get(labelKey);
    const value = item.get(valueKey);const handleItemRemove = () => this.handleItemRemove(item);
    const tagItemCss = Styles.tagItemCss(palette);

    return (
        <Chip
            onDelete={handleItemRemove}
            label={label}
            data-test-id="client-select-value"
            data-tip
            data-for={value}
            key={value}
            css={tagItemCss}
        />
    );
  },

  renderMenu() {
    const {theme} = this.context;
    const {
      searchUrl,
      searchParams,
      searchResultToItem,
      selectedItems,
      itemHeight,
      itemIcon,
      startItems,
      startItemStyle,
      startItemIcon,
      menuFooterCreatorFn,
      keys: [valueKey, , searchKey],
      maxHeight,
      showSelectedInDropdown
    } = this.props;
    const MenuFooter = menuFooterCreatorFn;
    const searchInput = this.state.searchInput;
    // Todo: Filter selected items
    const filteredStartItems = startItems &&
        startItems
            .filter(item => item.get(searchKey).toLowerCase().includes(searchInput))
    ;
    const listMaxHeight = showSelectedInDropdown
        ? (this.state.listMaxHeight != null ? this.state.listMaxHeight : this.getViewportCap())
        : maxHeight;
    const selectedItemEls = selectedItems.map(item => this.renderSelectedItem(item, theme.palette));
    const infiniteList = <InfiniteList
        searchPrefix={searchInput}
        searchUrl={searchUrl}
        searchParams={searchParams}
        searchResultToItem={searchResultToItem}
        itemIcon={itemIcon}
        itemHeight={itemHeight}
        startItems={filteredStartItems}
        startItemStyle={startItemStyle}
        startItemIcon={startItemIcon}
        selectedItemIds={selectedItems.map(item => item.get(valueKey))}
        onItemClick={this.handleItemClick}
        keys={this.props.keys}
        maxHeight={listMaxHeight} />;
    if (showSelectedInDropdown) {
      return (
          <div ref={this.setMenuRef} css={DropdownSections.dropdownContainerCss} onClick={this.focusInput}>
            <div css={DropdownSections.dropdownHeadingCss(theme)}>Selected <span
                style={{
                  float: "right",
                  color: theme.palette.primary.main,
                  cursor: "pointer"
                }} onClick={this.handleRemoveAllItems}>Remove all</span>
            </div>
            <div ref={this.setSelectedSectionRef} css={DropdownSections.selectedSectionCss}>{selectedItemEls}</div>
            <div css={DropdownSections.dropdownHeadingCss(theme)}>Available</div>
            <div ref={this.setAvailableRef} css={[DropdownSections.availableSectionCss, DropdownSections.availableSectionVirtualizedCss]}>{infiniteList}</div>
            <div ref={this.setFooterRef} css={DropdownSections.menuFooterCss}>
              <MenuFooter closeMenu={this.closeMenu} />
            </div>
          </div>
      );
    }
    return (
        <div style={{marginTop: "0.5rem"}} onClick={this.focusInput}>
          {infiniteList}
          <MenuFooter closeMenu={this.closeMenu} />
        </div>
    );
  },

  getViewportCap() {
    return Math.round((typeof window !== "undefined" ? window.innerHeight : 800) * 0.6);
  },

  measureListMaxHeight() {
    const menu = this.menuRef;
    const available = this.availableRef;
    if (!menu || !available) {
      return;
    }
    const chromeAbove = available.getBoundingClientRect().top - menu.getBoundingClientRect().top;
    const footerHeight = this.footerRef ? this.footerRef.getBoundingClientRect().height : 0;
    const listMaxHeight = Math.max(
        this.props.itemHeight,
        Math.round(this.getViewportCap() - chromeAbove - footerHeight));
    if (listMaxHeight !== this.state.listMaxHeight) {
      this.setState({listMaxHeight});
    }
  },

  recomputeListMaxHeight() {
    cancelAnimationFrame(this.recomputeFrame);
    this.recomputeFrame = requestAnimationFrame(() => this.measureListMaxHeight());
  },

  setMenuRef(node) {
    this.menuRef = node;
    if (node) {
      if (typeof ResizeObserver !== "undefined" && !this.menuResizeObserver) {
        // Fires as the open animation settles and on later layout changes.
        this.menuResizeObserver = new ResizeObserver(() => this.recomputeListMaxHeight());
        this.menuResizeObserver.observe(node);
      }
      if (!this.onWindowResize) {
        this.onWindowResize = () => this.recomputeListMaxHeight();
        window.addEventListener("resize", this.onWindowResize);
      }
      // Measure synchronously on initial mount so the correct height is committed
      // before the browser paints — avoids the visible resize jerk on open.
      this.measureListMaxHeight();
    } else {
      this.teardownMenuMeasurement();
    }
  },

  setAvailableRef(node) {
    this.availableRef = node;
  },

  setSelectedSectionRef(node) {
    this.selectedSectionRef = node;
  },

  setFooterRef(node) {
    this.footerRef = node;
  },

  teardownMenuMeasurement() {
    if (this.menuResizeObserver) {
      this.menuResizeObserver.disconnect();
      this.menuResizeObserver = null;
    }
    if (this.onWindowResize) {
      window.removeEventListener("resize", this.onWindowResize);
      this.onWindowResize = null;
    }
    cancelAnimationFrame(this.recomputeFrame);
    this.menuRef = null;
    this.availableRef = null;
    this.footerRef = null;
    this.selectedSectionRef = null;
  },

  handleClickOutside() {
    this.closeMenu();
  },

  focusInput() {
    this.input.focus();
  },

  openMenu() {
    if (!this.props.disabled) {
      this.props.onOpenStateChange && this.props.onOpenStateChange(true);
      this.setState({isOpen: true});
      this.focusInput();
    }
  },

  closeMenu() {
    if(this.state.isOpen) {
      this.props.onOpenStateChange && this.props.onOpenStateChange(false);
      this.setState(this.getInitialState());
      this.props.onRequestClose();
    }
  },

  handleInputChange(e) {
    const input = e.target.value;
    this.setState({searchInput: input.toLowerCase()});
    this.props.onInputChange(input);
  },

  handleItemRemove(item) {
    const {
      selectedItems,
      onChange
    } = this.props;
    onChange(selectedItems.delete(item));
  },

  handleRemoveAllItems() {
    this.props.onChange(Immutable.Set());
  },

  handleItemClick(item) {
    const {
      selectedItems,
      onChange,
      keys: [valueKey, labelKey],
      closeOnSelect
    } = this.props;

    const newItem = item
        .delete("id")
        .delete("name")
        .update(valueKey, () => item.get("id"))
        .update(labelKey, () => item.get("name"));

    const newItems = selectedItems.add(newItem);
    onChange(newItems);

    if (closeOnSelect) {
      this.closeMenu();
    }
  }
});
InfiniteListSelect.contextType = CustomThemeContext;

export default onClickOutside(InfiniteListSelect);
